export type Role = {
  id: number;
  name: string;
  display_name: string;
  description?: string;
  is_system_role?: boolean;
};

export type User = {
  id?: number;
  username: string;
  role: 'admin' | 'teacher' | 'viewer';
  roles?: Role[];
  use_rbac?: boolean;
  password?: string;
  hasPhoto?: boolean;
  hasGoogle?: boolean;
  googleEmail?: string;
  createdAt?: string;
};

export const defaultUser: User = {
  username: '',
  role: 'viewer',
  password: '',
};
